export default "__VITE_ASSET__DGBBKRbe__"